import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom'
import { BbIcon } from '../../components/BbIcon'
import { BbStepper } from '../../components/BbStepper'
import { useDeleteWizard } from '../../delete/DeleteWizardContext'
import { formatInt } from '../../lib/format'
import { DELETE_STEPS } from './steps'

/* Step 5, ported from "batchbooks_delete_step_5_submitted".

   The job is submitted by the Confirm button (DeleteConfirmPage), which then
   navigates here with { jobId }. Nothing calls the API on this screen — a submit
   in an effect double-fired under React StrictMode and queued two jobs per click,
   so the only side effect here is presenting the job that was already created.

   A 202 only means the job was queued; the worker resolves the targets against
   QuickBooks and deletes them one at a time, and some may be rejected. The
   wording stays at "submitted" and points at the job page for the actual
   per-record outcome. */
export function DeleteDonePage() {
  const wizard = useDeleteWizard()
  const navigate = useNavigate()
  const { state } = useLocation()

  const jobId = (state as { jobId?: string } | null)?.jobId ?? null

  if (!wizard.entityType) return <Navigate to="/app/delete" replace />

  const subject = wizard.entity?.label ?? wizard.entityType
  const count = wizard.review?.length ?? (wizard.source === 'refs' ? wizard.refList.length : null)

  const startOver = () => {
    wizard.reset()
    navigate('/app/delete')
  }

  return (
    <div className="bb bb-wizard">
      <BbStepper steps={DELETE_STEPS} current={4} />

      <div className="bb-panel-card">
        <div className="bb-panel-card-b">
          <div className="bb-success">
            <span className="bb-success-ico">
              <BbIcon name="check-circle" />
            </span>
            <h2>Deletion Job Submitted</h2>
            <p>
              Your request to delete{' '}
              <b>
                {count === null ? 'the selected' : formatInt(count)} {subject}
                {count === 1 ? '' : 's'}
              </b>{' '}
              is queued. Deletion happens record by record, so check the job page for which ones
              QuickBooks accepted.
            </p>
          </div>
        </div>
      </div>

      <div className="bb-wizard-foot">
        <button className="bb-btn bb-btn-quiet" type="button" onClick={startOver}>
          Start New Deletion
        </button>
        <span className="bb-wizard-foot-r">
          <Link className="bb-btn bb-btn-navy" to={jobId ? `/app/jobs/${jobId}` : '/app/jobs'}>
            <BbIcon name="history" />
            {jobId ? 'View this job' : 'Go to Job History'}
          </Link>
        </span>
      </div>
    </div>
  )
}
